import { render, staticRenderFns } from "./RouterButton.vue?vue&type=template&id=2fdc75fb&scoped=true"
import script from "./RouterButton.vue?vue&type=script&lang=js"
export * from "./RouterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc75fb",
  null
  
)

export default component.exports